import React, { useState } from "react";

import { AppBar, Toolbar, IconButton, Typography, useTheme, Container, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";

import { Box, Menu, Avatar, Tooltip, MenuItem } from "@mui/material";

import { useLanguage } from "../../hooks/useLanguage";
import { useTranslation } from "react-i18next";

export const Header = () => {
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage, getSupportedLanguages } = useLanguage();

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleLanguageChange = async (event: React.MouseEvent<HTMLElement>, newAlignment: any) => {
    if (!newAlignment) return; // 防止取消选择
    
    // 使用新的语言钩子进行切换
    const languageCode = newAlignment === "zhCN" ? "zh-CN" : "en-US";
    await changeLanguage(languageCode);
  };

  return (
    <AppBar 
      position="static" 
      sx={{ 
        backgroundColor: "rgba(255, 255, 255, 0.9)", 
        color: theme.palette.primary.dark,
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.2)"
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "center",
              padding: "8px 16px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, rgba(251, 78, 43, 0.1) 0%, rgba(255, 255, 255, 0.8) 100%)",
              border: "1px solid rgba(251, 78, 43, 0.1)",
              boxShadow: "0 2px 8px rgba(251, 78, 43, 0.1)",
              transition: "all 0.3s ease",
              cursor: "pointer",
              '&:hover': {
                transform: "translateY(-2px)",
                boxShadow: "0 4px 16px rgba(251, 78, 43, 0.2)",
                background: "linear-gradient(135deg, rgba(251, 78, 43, 0.15) 0%, rgba(255, 255, 255, 0.9) 100%)"
              }
            }}
          >
            <Avatar 
              variant="square" 
              alt="Wise Memo" 
              src="/logo.svg" 
              sx={{ 
                width: 32, 
                height: 32,
                mr: 1,
                filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))"
              }} 
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                background: "linear-gradient(135deg, #FB4E2B 0%, #FF6B6B 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
              }}
            >
              {t("titleWiseMemo")}
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {/* {[t('menuAbout')].map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: theme.palette.primary.dark, display: 'block' }}
              >
                {page}
              </Button>
            ))} */}
          </Box>
          <Box sx={{ flexGrow: 0, ml: 2, marginLeft: "auto" }}>
            <ToggleButtonGroup 
              value={currentLanguage} 
              exclusive 
              onChange={handleLanguageChange} 
              size="small" 
              color="primary"
              sx={{
                background: "rgba(255, 255, 255, 0.8)",
                borderRadius: "8px",
                padding: "2px",
                border: "1px solid rgba(251, 78, 43, 0.1)"
              }}
            >
              <ToggleButton 
                value="zhCN"
                sx={{
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: 600,
                  minWidth: "40px",
                  '&.Mui-selected': {
                    background: "linear-gradient(135deg, #FB4E2B 0%, #FF6B6B 100%)",
                    color: "white",
                    boxShadow: "0 2px 8px rgba(251, 78, 43, 0.3)"
                  }
                }}
              >
                {t("langZh")}
              </ToggleButton>
              <ToggleButton 
                value="enUS"
                sx={{
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: 600,
                  minWidth: "40px",
                  '&.Mui-selected': {
                    background: "linear-gradient(135deg, #FB4E2B 0%, #FF6B6B 100%)",
                    color: "white",
                    boxShadow: "0 2px 8px rgba(251, 78, 43, 0.3)"
                  }
                }}
              >
                {t("langEn")}
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
